export default {"src":"/_next/static/media/right_outline.d635fff2.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};